import HeadSeo from "components/HeadSeo/HeadSeo";
import { COUNTRY_CONFIG } from "Config/country";
import siteMetadata from "data/siteMetadata";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { selectors as ListingsreducerSelectors } from "redux/slices/v2/ListingReducer";
import { set_size } from "utils/getImageToDisplay";
import { BienTypes } from "pagesHelpers/ListingPagesHepler/SlugTransformation";
import { buildUrl, norm } from "components/v2/Listings/ListingsRouterUrlHelper";
import formatUrl, { nextRewriteRules } from "utils/FormatUrl";
import { buildListingTitle } from "utils/generateFeeds/generateRssFeed";
import { current } from "@reduxjs/toolkit";
import { log } from "console";

const DEFAULT_TITLE = {
  Vente:
    "Achat Appartement, Maison, Villa | Annonces  immobilières de vente  | Agenz",
  Location:
    "Location immobilière | Location appartement | Maison à louer  | Agenz",
  "Projets Neufs":
    "Immobilier neuf | Programme neuf | Achat logement neuf  | Agenz",
};

const DEFAULT_DESCRIPTON = {
  Vente:
    "Achat Appartement, Maison, Villa : Consultez ces annonces exclusives d’appartements et villas à vendre , uniquement sur Agenz",
  Location:
    "Location immobilière, Location appartement , Maison à louer : Toutes les annonces immobilières de location au Maroc avec Agenz.",
  "Projets Neufs":
    "Immobilier neuf, Programme neuf : Annonces de villas et appartements neufs à vendre. Trouvez le bien de vos rêves partout au Maroc sur Agenz.",
};

const PATHS = {
  Vente: "acheter",
  Location: "louer",
  "Projets Neufs": "acheter",
};

export const getSurface = (listing) => {
  if (listing?.type === "Terrain") {
    return listing?.terrainSurface
      ? listing?.terrainSurface
      : listing?.surface
      ? listing?.surface
      : 0;
  }
  return listing?.surface
    ? listing?.surface
    : listing?.surfaceterrain
    ? listing?.surfaceterrain
    : listing?.surfaceconstruite
    ? listing?.surfaceconstruite
    : 0;
};
export let match_bien_types_neufs = {
  Appartement: "neufs",
  Terrain: "neufs",
  Maison: "neuves",
  Villa: "neuves",
  Riad: "neufs",
  Bureau: "neufs",
  Bureaux: "neufs",
  Commerces: "neufs",
  "Local Industriel": "neufs",
};
export const singulartWithArticle = (bienType, typologie) => {
  if (bienType == "Appartement") {
    return typologie === 0 ||
      (typeof typologie == "object" &&
        typologie.length == 1 &&
        typologie[0] === 0)
      ? "le studio"
      : "l'appartement";
  }
  return bienType === "Bureau"
    ? "le bureau"
    : bienType === "Local Industriel"
    ? "le local industriel"
    : bienType === "Maison"
    ? "la maison"
    : bienType === "Riad"
    ? "le riad"
    : bienType === "Villa"
    ? "la villa"
    : bienType === "Terrain"
    ? "le terrain"
    : "le bien immobilier";
};
export const pluralWithArticle = (bienType, typologie) => {
  if (bienType == "Appartement") {
    return typologie === 0 ||
      (typeof typologie == "object" &&
        typologie.length == 1 &&
        typologie[0] === 0)
      ? "de studios"
      : "d'appartements";
  }
  return bienType === "Bureau"
    ? "de bureaux"
    : bienType === "Local Industriel"
    ? "de locaux industriels"
    : bienType === "Maison"
    ? "de maisons"
    : bienType === "Riad"
    ? "de riads"
    : bienType === "Villa"
    ? "de villas"
    : bienType === "Terrain"
    ? "de terrains"
    : "de biens immobiliers";
};
export const bienTypeGenre = (bienType) => {
  return bienType == "Appartement" ||
    bienType == "Local Indsutriel" ||
    bienType == "Riad" ||
    bienType == "Terrain" ||
    bienType == "Bureau"
    ? "M"
    : "F";
};
export const pluralOf = (bienType, typologie: any = 1) => {
  if (bienType == "Annonces exclusives Agenz") {
    return bienType;
  }
  if (bienType == "Appartement") {
    return typologie === 0 ||
      (typeof typologie == "object" &&
        typologie.length == 1 &&
        typologie[0] === 0)
      ? "Studios"
      : "Appartements";
  }
  return bienType === "Bureau"
    ? "Bureaux"
    : bienType === "Local Industriel"
    ? "Locaux Industriels"
    : `${bienType}s`;
};
export const buildDescriptionListingPage = (
  transaction_type,
  bienType,
  region,
  province,
  commune,
  quartier,
  title_complement,
  typologie,
  t = (e) => {
    return e;
  }
) => {
  // let description = `${t(pluralOf(bienType, typologie))} ${t(
  //   `à ${transaction_type == "Location" ? "louer" : "vendre"}`
  // )}${
  //   quartier && typeof quartier == "string"
  //     ? ` ${t("à")} ${t(quartier)}  - ${
  //         commune
  //           ? `${t(commune)}`
  //           : province
  //           ? `${t(province)}`
  //           : region
  //           ? `${t(region)}`
  //           : ""
  //       }`
  //     : commune
  //     ? ` ${t("à")} ${t(commune)}`
  //     : province
  //     ? ` ${t("à")} ${t(province)}`
  //     : region
  //     ? ` ${t("à")} ${t(region)}`
  //     : ` ${t("partout au Maroc")}`
  // }${
  //   title_complement
  //     ? title_complement.startsWith(" ")
  //       ? title_complement
  //       : ` ${title_complement}`
  //     : ""
  // } | ${t(
  //   "Consultez ces annonces exclusives d’appartements et villas à vendre , uniquement sur agenz"
  // )}`;
  return `${t("Découvrez nos")} ${t(
    pluralOf(bienType, typologie)
  ).toLowerCase()} ${t(
    `à ${transaction_type == "Location" ? "louer" : "vendre"}`
  )}${
    quartier && typeof quartier == "string"
      ? ` ${t("à")} ${t(quartier)} - ${
          commune
            ? `${t(commune)}`
            : province
            ? `${t(province)}`
            : region
            ? `${t(region)}`
            : ""
        }`
      : commune
      ? ` ${t("à")} ${t(commune)}`
      : province
      ? ` ${t("à")} ${t(province)}`
      : region
      ? ` ${t("à")} ${t(region)}`
      : ` ${t("partout au Maroc")}`
  }${
    title_complement
      ? title_complement.startsWith(" ")
        ? title_complement
        : ` ${title_complement}`
      : ""
  } ${t("sur agenz")}. ${
    transaction_type == "Location" ? t("Louer") : t("Acheter")
  } ${t(singulartWithArticle(bienType, typologie))} ${t(
    `idéal${bienTypeGenre(bienType) == "M" ? "" : "e"}`
  )} ${t("avec nos annonces exclusives")} ${t(
    pluralWithArticle(bienType, typologie)
  )} ${transaction_type == "Location" ? t("à louer") : t("à vendre")}${
    quartier && typeof quartier == "string"
      ? ` ${t("à")} ${t(quartier)} - ${
          commune
            ? `${t(commune)}`
            : province
            ? `${t(province)}`
            : region
            ? `${t(region)}`
            : ""
        }`
      : commune
      ? ` ${t("à")} ${t(commune)}`
      : province
      ? ` ${t("à")} ${t(province)}`
      : region
      ? ` ${t("à")} ${t(region)}`
      : ` ${t("partout au Maroc")}`
  }.`;
};

export const buildPageTitle = (
  transaction_type,
  bienType,
  region,
  province,
  commune,
  quartier,
  title_complement,
  typologie,
  t = (e) => {
    return e;
  }
) => {
  return `${t(pluralOf(bienType, typologie))} ${t(
    `à ${transaction_type == "Location" ? t("louer") : t("vendre")}`
  )}${
    quartier && typeof quartier == "string"
      ? ` ${t("à")} ${t(quartier)} - ${
          commune
            ? `${t(commune)}`
            : province
            ? `${t(province)}`
            : region
            ? `${t(region)}`
            : ""
        }`
      : commune
      ? ` ${t("à")} ${t(commune)}`
      : province
      ? ` ${t("à")} ${t(
          province.replace("Nouaceur", "Bouskoura et Dar Bouazza")
        )}`
      : region
      ? ` ${t("à")} ${region}`
      : ` ${t("partout au Maroc")}`
  }${
    title_complement
      ? title_complement.startsWith(" ")
        ? title_complement
        : ` ${title_complement}`
      : ""
  } | ${t("Agenz")}`;
};
export const formatNumberWithContext = (number, isRTL: boolean) => {
  var formattedNumber = number.toString().replace(/(.)(?=(\d{3})+$)/g, "$1 ");

  return isRTL
    ? formattedNumber.split(" ").reverse().join(" ")
    : formattedNumber;
};

export const buildListingDefaultDescription = (
  currentListing,
  t = (e) => {
    return e;
  },
  lang = "fr"
) => {
  return `${
    currentListing.transaction_type == "Location" ? t("Louer") : t("Acheter")
  } ${t(
    singulartWithArticle(currentListing.type, currentListing.typologie)
  )} ${t(`idéal${bienTypeGenre(currentListing.type) == "M" ? "" : "e"}`)} ${t(
    "sur agenz"
  )} - ${t("Découvrez ce")} ${t(currentListing.type)} ${
    currentListing.transaction_type == "Location" ? t("à louer") : t("à vendre")
  }${
    currentListing.prix
      ? ` ${formatNumberWithContext(currentListing.prix, lang == "ar")} ${t(
          "dh"
        )}`
      : ""
  }${
    currentListing.quartier && typeof currentListing.quartier == "string"
      ? ` ${t("à")} ${t(currentListing.quartier)} - ${
          currentListing.commune
            ? `${t(currentListing.commune)} - ${t(currentListing.province)}`
            : currentListing.province
            ? `${t(currentListing.province)}`
            : currentListing.region
            ? `${t(currentListing.region)}`
            : ""
        }`
      : currentListing.commune
      ? ` ${t("à")} ${t(currentListing.commune)} - ${t(
          currentListing.province
        )}`
      : currentListing.province
      ? ` ${t("à")} ${t(currentListing.province)}`
      : currentListing.region
      ? ` ${t("à")} ${t(currentListing.region)}`
      : ""
  }`;
};

const getSeoHeadData = ({
  t,
  lang,
  region,
  province,
  commune,
  quartier,
  title_complement,
  currentListing,
  annonceSlug,
  bienType,
  viewType,
  typologie = 1,
}: {
  t: any;
  lang?: any;
  region?: string;
  province?: string;
  commune?: string;
  quartier?: any;
  title_complement;
  currentListing?: any;
  annonceSlug?: string;
  bienType?: BienTypes;
  viewType: "Vente" | "Location" | "Projets Neufs" | "";
  typologie?: any;
}) => {
  let title = DEFAULT_TITLE[viewType];
  let description = t(DEFAULT_DESCRIPTON[viewType]);

  var regex = /(<([^>]+)>)/gi;

  if (annonceSlug && annonceSlug !== "") {
    // case we have all infos /type/region/province/commune/annonceSlug

    if (
      viewType === "Location" ||
      viewType === "Vente" ||
      viewType === "Projets Neufs"
    ) {
      title = buildListingTitle(currentListing, t, lang);
      description =
        lang == "fr"
          ? currentListing?.Description
            ? currentListing?.Description.replace(/<[^>]*>?/gm, "").length > 100
              ? currentListing?.Description.replace(/<[^>]*>?/gm, "").substring(
                  0,
                  156
                )
              : buildListingDefaultDescription(currentListing, t, lang)
            : buildListingDefaultDescription(currentListing, t, lang)
          : lang == "ar" ? currentListing?.Description_ar
            ? currentListing?.Description_ar.replace(/<[^>]*>?/gm, "").length >
              100
              ? currentListing?.Description_ar.replace(
                  /<[^>]*>?/gm,
                  ""
                ).substring(0, 156)
              : buildListingDefaultDescription(currentListing, t, lang)
            : buildListingDefaultDescription(currentListing, t, lang)
          : currentListing?.Description_en
            ? currentListing?.Description_en.replace(/<[^>]*>?/gm, "").length >
              100
              ? currentListing?.Description_en.replace(
                /<[^>]*>?/gm,
                ""
              ).substring(0, 156)
              : buildListingDefaultDescription(currentListing, t, lang)
            : buildListingDefaultDescription(currentListing, t, lang);
      title = title.replace(regex, "");
      description = description.replace(regex, "");
    }

    title = title.replace(regex, "");
    description = description.replace(regex, "");
  } else {
    if (bienType) {
      title = buildPageTitle(
        viewType,
        bienType,
        region,
        province,
        commune,
        quartier,
        title_complement,
        typologie,
        t
      );
      description = buildDescriptionListingPage(
        viewType,
        bienType,
        region,
        province,
        commune,
        quartier,
        title_complement,
        typologie,
        t
      );
    } else if (province) {
      title = `${t(
        `Immobilier et maisons à ${viewType == "Location" ? "louer" : "vendre"}`
      )} ${t("à")} ${t(province)} | ${t("Agenz")}`;
      description = `${t(
        `Immobilier et maisons à ${viewType == "Location" ? "louer" : "vendre"}`
      )} ${t("à")} ${t(province)} | ${t(
        "Consultez ces annonces exclusives d’appartements et villas à vendre , uniquement sur agenz"
      )}`;
    } else {
      title = `${t(
        `Immobilier et maisons à ${viewType == "Location" ? "louer" : "vendre"}`
      )} ${t("partout au Maroc")} | ${t("Agenz")}`;
      description = `${t(
        `Immobilier et maisons à ${viewType == "Location" ? "louer" : "vendre"}`
      )} ${t("partout au Maroc")} | ${t(
        "Consultez ces annonces exclusives d’appartements et villas à vendre , uniquement sur agenz"
      )}`;
    }
  }

  let ogImageUrl =
    "https://storage.googleapis.com/headers-agenz/Logo%20300_%20300%20px.jpg";

  if (currentListing && currentListing.images && currentListing.images[0]) {
    ogImageUrl = set_size(currentListing.images[0], "250x250", "webp");
  }
  return {
    title,
    description,
    ogTitle: title,
    ogDescription: description,
    ogImageUrl,
  };
};

const makeStructuredData = ({
  title,
  url,
  t,
  lang,
  region,
  province,
  commune,
  bienType,
  viewType,
  listing,
  page,
}: {
  title?: string;
  url?: string;
  t?: any;
  lang;
  region?: string;
  province?: string;
  commune?: string;
  annonceSlug?: string;
  bienType?: string;
  viewType: "Vente" | "Location" | "Projets Neufs" | "";
  listing: any;
  page: any;
}) => {
  const data = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    itemListElement: [],
  };

  let cumulativeUrl = `https://agenz.ma/${PATHS[viewType]}`;

  const mainLayer: any = {
    name: t(DEFAULT_TITLE[viewType]),
    item: cumulativeUrl,
  };

  const layers = [
    {
      transformer: (layer) => `immo-${norm(layer)}`,
      variable: province,
      type: "province",
    },
    {
      transformer: (layer) => {
        if (viewType == "Location") {
          switch (norm(layer)) {
            case "appartement":
              return "location-appartements";
            case "villa":
              return "location-villas";
            case "maison":
              return "location-maisons";
            case "maison":
              return "location-maisons";
            case "riad":
              return "location-riads";
            case "bureau":
              return "location-bureaux";
            case "terrain":
              return "location-terrains";
            case "commerce":
              return "location-locaux-magasins";
            case "local-industriel":
              return "location-locaux-industriels";
            default:
              return "";
          }
        } else {
          switch (norm(layer)) {
            case "appartement":
              return "vente-appartements";
            case "villa":
              return "vente-villas";
            case "maison":
              return "vente-maisons";
            case "maison":
              return "vente-maisons";
            case "riad":
              return "vente-riads";
            case "bureau":
              return "vente-bureaux";
            case "terrain":
              return "vente-terrains";
            case "commerce":
              return "vente-locaux-magasins";
            case "local-industriel":
              return "vente-locaux-industriels";
            default:
              return "";
          }
        }
      },
      variable: bienType,
      type: "type_de_bien",
    },

    {
      transformer: (layer) => norm(layer),
      variable: norm(listing?.slug.split("/").slice(-1)[0]),
      type: "slug",
    },
  ];

  let result = [mainLayer];
  layers.forEach((layer) => {
    cumulativeUrl = layer.variable
      ? cumulativeUrl + `/${layer.transformer(layer.variable)}`
      : cumulativeUrl;

    if (layer.variable) {
      result.push({
        name:
          layer.type == "slug"
            ? title
            : `${DEFAULT_TITLE[viewType]} - ${layer.variable}`,
        item: cumulativeUrl,
      });
    }
  });
  if (listing) {
    let special_ld = {
      name: title,
      type: "RealEstateListing",
      datePosted: listing.date ? listing.date : new Date().toISOString(),
      primaryImageOfPage: listing.images[0],
      image: listing.images[0],
      abstract: listing.Description
        ? listing.Description.replace(/<[^>]*>?/gm, "")
        : "Annonces immobilière sur agenz.ma",
      url: `https://agenz.ma/${formatUrl(nextRewriteRules(url), lang).replace(
        "https://agenz.ma/",
        ""
      )}`,
    };
    if (
      listing.type == "Appartement" ||
      listing.type == "Villa" ||
      listing.type == "Maison" ||
      listing.type == "Riad"
    ) {
      (special_ld["numberOfBedrooms"] = listing.typologie),
        (special_ld["floorSize"] =
          listing.surface ||
          listing.surfaceterrain ||
          listing.surfaceconstruite),
        (special_ld["floorLevel"] = listing.etage),
        (special_ld["latitude"] = listing.lat),
        (special_ld["longitude"] = listing.lng),
        (special_ld["photo"] = listing.images[0]);
    }
    if (listing.type == "Appartement") {
      delete special_ld["abstract"];
      delete special_ld["datePosted"];
      delete special_ld["primaryImageOfPage"];
      delete special_ld["position"];
      special_ld["type"] = "Apartment";
      special_ld["additionalType"] = "RealEstateListing";
    }
    if (
      listing.type == "Villa" ||
      listing.type == "Maison" ||
      listing.type == "Riad"
    ) {
      delete special_ld["abstract"];
      delete special_ld["datePosted"];
      delete special_ld["primaryImageOfPage"];
      delete special_ld["position"];
      special_ld["type"] = "House";
      special_ld["additionalType"] = "RealEstateListing";
    }
    result.push({
      name: title,
      item: special_ld,
    });
  }

  data.itemListElement = result.map((item, index) => {
    let new_markup: any = {
      "@type": "ListItem",
      position: index + 1,
      ...item,
    };
    // if (!item.type) {
    //   new_markup["position"] = index + 1;
    // }
    return new_markup;
  });

  let to_return: any = [data];
  if (listing) {
    let RealEstateListingLD = {
      "@context": "https://schema.org/",
      "@type": "RealEstateListing",
      name: title,
      datePosted: listing.date ? listing.date : new Date().toISOString(),
      primaryImageOfPage: listing.images[0],
      image: listing.images[0],
      abstract: listing.Description
        ? listing.Description.replace(/<[^>]*>?/gm, "")
        : "Annonces immobilière sur agenz.ma",
      url: `https://agenz.ma/${formatUrl(nextRewriteRules(url), lang)}`,
    };
    to_return.push(RealEstateListingLD);
    let AccomodationLd = {
      "@context": "https://schema.org/",
      "@type": "Apartment",
    };
    if (listing.type == "Appartement") {
      AccomodationLd["type"] = "Apartment";
      AccomodationLd["additionalType"] = "RealEstateListing";
    }
    if (
      listing.type == "Villa" ||
      listing.type == "Maison" ||
      listing.type == "Riad"
    ) {
      AccomodationLd["type"] = "House";
      AccomodationLd["additionalType"] = "RealEstateListing";
    }
    if (
      listing.type == "Appartement" ||
      listing.type == "Villa" ||
      listing.type == "Maison" ||
      listing.type == "Riad"
    ) {
      (AccomodationLd["numberOfBedrooms"] = listing.typologie),
        (AccomodationLd["floorSize"] =
          listing.surface ||
          listing.surfaceterrain ||
          listing.surfaceconstruite),
        (AccomodationLd["floorLevel"] = listing.etage),
        (AccomodationLd["latitude"] = listing.lat),
        (AccomodationLd["longitude"] = listing.lng),
        (AccomodationLd["photo"] = listing.images[0]);
      to_return.push(AccomodationLd);
    }
  }

  return {
    structuredData: {
      __html: listing ? JSON.stringify(to_return) : JSON.stringify(data),
    },
    cumulativeUrl: page
      ? `${cumulativeUrl}?page=${page.toString()}`
      : cumulativeUrl,
  };
};

export default function HeadSeoHelper({
  t,
  lang,
  initialListings,
  region,
  province,
  commune,
  quartier,
  title_complement,
  currentListing,
  annonceSlug,
  bienType,
  viewType,
  page,
  url,
}: {
  t: any;
  lang: any;
  initialListings?: any[];
  region?: string;
  province?: string;
  commune?: string;
  quartier?: string;
  title_complement?: any;
  currentListing?: any;
  annonceSlug?: string;
  bienType?: any;
  viewType: "Vente" | "Location" | "Projets Neufs" | "";
  page: number;
  url?: string;
}) {
  const searchPayload = useSelector(
    ListingsreducerSelectors.searchPayloadSelector
  );
  const initialSearchPayloadSSR = useSelector(
    ListingsreducerSelectors.initialSearchPayloadSelector
  );

  const { title, description, ogImageUrl, ogTitle, ogDescription } =
    getSeoHeadData({
      t: t,
      lang,
      region: region,
      province: province,
      commune: commune,
      quartier: quartier,
      title_complement: title_complement,
      currentListing: currentListing,
      annonceSlug: annonceSlug,
      bienType: bienType,
      viewType: viewType,
      typologie: initialSearchPayloadSSR?.typologie,
    });
  const structuredUrlData = makeStructuredData({
    title,
    url,
    t,
    lang,
    region: region,
    province: province,
    commune: commune,
    annonceSlug: annonceSlug,
    bienType: bienType,
    viewType: viewType,
    listing: currentListing,
    page: page,
  });

  const [headSeoData, setHeadSeoData] = useState<any>({
    title: title,
    description: description,
    ogImageUrl: ogImageUrl,
    ogTitle: ogTitle,
    ogDescription: ogDescription,
    canonicalUrl: buildUrl(
      currentListing,
      initialSearchPayloadSSR,
      searchPayload,
      "LIST",
      url,
      searchPayload.page
    ),
    structuredData: structuredUrlData.structuredData,
  });
  const firstUpdate = useRef(true);
  const firstUpdateCL = useRef(true);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    } else {
      if (searchPayload) {
        const { title, description, ogImageUrl, ogTitle, ogDescription } =
          getSeoHeadData({
            t: t,
            lang,
            region: searchPayload.region,
            province: searchPayload.province,
            commune: searchPayload.commune,
            quartier: searchPayload.quartier,
            title_complement: title_complement,
            currentListing: currentListing,
            annonceSlug: currentListing?.slug,
            bienType: currentListing?.type
              ? currentListing?.type
              : searchPayload.type.length
              ? searchPayload.type[0]
              : null,
            viewType: currentListing
              ? (currentListing?.transaction_type as
                  | "Vente"
                  | "Location"
                  | "Projets Neufs")
              : viewType,
            typologie: initialSearchPayloadSSR?.typologie,
          });

        const structuredUrlData = makeStructuredData({
          title,
          url,
          t,
          lang,
          region: region,
          province: province,
          commune: commune,
          annonceSlug: annonceSlug,
          bienType: bienType,
          viewType: viewType,
          listing: currentListing,
          page: page,
        });
        setHeadSeoData({
          title:
            currentListing && currentListing?.projectName
              ? currentListing.projectName
              : title,
          description,
          ogImageUrl,
          ogTitle,
          ogDescription,
          canonicalUrl: structuredUrlData.cumulativeUrl,
          structuredData: structuredUrlData.structuredData,
        });
      }
    }
  }, [searchPayload]);

  useEffect(() => {
    if (firstUpdateCL.current) {
      firstUpdateCL.current = false;
      return;
    } else {
      if (searchPayload) {
        const { title, description, ogImageUrl, ogTitle, ogDescription } =
          getSeoHeadData({
            t: t,
            lang,
            region: searchPayload.region,
            province: searchPayload.province,
            commune: searchPayload.commune,
            quartier: searchPayload.quartier,
            title_complement: title_complement,
            currentListing: currentListing,
            annonceSlug: currentListing?.slug,
            bienType: currentListing?.type
              ? currentListing?.type
              : searchPayload.type.length
              ? searchPayload.type[0]
              : null,
            viewType: currentListing
              ? (currentListing?.transaction_type as
                  | "Vente"
                  | "Location"
                  | "Projets Neufs")
              : viewType,
            typologie: initialSearchPayloadSSR?.typologie,
          });

        const structuredUrlData = makeStructuredData({
          title,
          url,
          t,
          lang,
          region: region,
          province: province,
          commune: commune,
          annonceSlug: annonceSlug,
          bienType: bienType,
          viewType: viewType,
          listing: currentListing,
          page: page,
        });
        setHeadSeoData({
          title:
            currentListing && currentListing?.projectName
              ? currentListing.projectName
              : title,
          description,
          ogImageUrl,
          ogTitle,
          ogDescription,
          canonicalUrl: `https://agenz.ma/${formatUrl(
            nextRewriteRules(url),
            lang
          )}`,
          structuredData: structuredUrlData.structuredData,
        });
      }
    }
  }, [currentListing]);

  return (
    <HeadSeo
      title={headSeoData.title}
      description={headSeoData.description}
      ogImageUrl={headSeoData.ogImageUrl}
      ogTwitterImage={siteMetadata.siteLogoSquare}
      ogType={"website"}
      ogTitle={headSeoData.ogTitle}
      ogDescription={headSeoData.ogDescription}
      canonicalUrl={headSeoData.canonicalUrl}
      structuredData={headSeoData.structuredData}
    />
  );
}
